import { router, usePage } from "@inertiajs/react";
import { FiArrowLeft } from "react-icons/fi";

import SummaryCard from "@/components/Cards/Investor/ResumeCard";
import Dropdown from "@/components/Dropdown";
import Typography from "@/components/Typography";
import { moneyCentsFormatterWithoutCurrency } from "@/utils/moneyFormat";

const SummarySection = ({
  allShareInitialInvestment,
  allShareQuantity,
  allShareTotalValue,
  allShareConstructionAppreciation = 0,
  allShareIpcaAppreciation = 0,
  lastDividend,
  dividendYield,
  years,
  currentYear,
  setCurrentYear,
  investorName,
}) => {
  const { url } = usePage();
  const urlParams = new URLSearchParams(url.split("?")[1]);
  const fromParam = urlParams.get("from");
  const consortiumId = urlParams.get("consortium_id");

  const isShowMode =
    fromParam === "consortium" || fromParam === "manager" || fromParam === "investment-manager";

  const handleGoBack = () => {
    if (fromParam === "consortium" && consortiumId) {
      router.get(`/manager/spes/${consortiumId}/investments`);
    } else if (fromParam === "manager") {
      router.get("/manager/investors");
    } else {
      history.back();
    }
  };

  const getFilterLabel = () => {
    if (currentYear === "Atual") {
      return "nos últimos 12 meses";
    }
    return `durante ${currentYear}`;
  };

  return (
    <section className="flex h-fit flex-col gap-5 pt-4">
      {/* Show header when in show mode */}
      {isShowMode && (
        <div className="from-primary50 mb-4 rounded-2xl bg-secondary-900 bg-gradient-to-r p-6 shadow-md">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-col gap-2">
              <Typography variant="overline" color="white" className="uppercase opacity-90">
                Visualizando investidor
              </Typography>
              {investorName ? (
                <Typography variant="h3" color="white" className="font-bold">
                  {investorName}
                </Typography>
              ) : (
                <Typography variant="h3" color="white" className="font-bold">
                  Perfil do Investidor
                </Typography>
              )}
            </div>
            <div
              onClick={handleGoBack}
              className="flex cursor-pointer items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 shadow-sm transition-all hover:shadow-md active:scale-95"
            >
              <FiArrowLeft className="text-primary500" size={20} />
              <Typography variant="btnLarge" color="primary500" className="font-semibold">
                Voltar
              </Typography>
            </div>
          </div>
        </div>
      )}

      <div className="flex h-fit items-center justify-between">
        <div className="flex h-full flex-col items-start gap-1 md:flex-row md:items-center md:gap-4">
          <Typography variant="h4" color="black">
            Resumo geral
          </Typography>
          <div className="hidden h-6 w-px bg-grey200 md:block" />
          <Typography variant="h6" color="secondary500" className="uppercase md:text-base">
            {allShareQuantity} cotas adquiridas
          </Typography>
        </div>
        <Dropdown options={years} onSelect={(e) => setCurrentYear(e)} defaultValue={currentYear} />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <SummaryCard
          value={moneyCentsFormatterWithoutCurrency(allShareInitialInvestment)}
          percent=""
          position="up"
          title="valor investido"
          money={true}
        />
        <SummaryCard
          value={moneyCentsFormatterWithoutCurrency(allShareTotalValue)}
          percent=""
          position="up"
          title="valor atual"
          money={true}
          tooltip={true}
          constructionAppreciation={allShareConstructionAppreciation}
          ipcaAppreciation={allShareIpcaAppreciation}
          initialInvestment={allShareInitialInvestment}
        />
        <SummaryCard
          value={moneyCentsFormatterWithoutCurrency(lastDividend.value)}
          percent=""
          position="up"
          title="Últimos dividendos"
          date={lastDividend.date}
          money={true}
        />
        <SummaryCard
          value={dividendYield + "%"}
          percent=""
          position="up"
          title="dividend yield"
          date={getFilterLabel()}
        />
      </div>
    </section>
  );
};

export default SummarySection;
